import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar } from '../components';

const Content = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  background: ${props => props.theme.fav.bg};
`;

const Settings = ({ theme }) => (
  <Screen theme={theme} title="Settings">
    <TopNavBar title="Settings" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content />
    <BottomTabBar selected="settings" />
  </Screen>
);

export default withTheme(Settings);



// WEBPACK FOOTER //
// ./src/screens/Settings.js